import { GlobalEvents } from 'Utils/constants';
//import { GetBreakpointWidth } from 'Utils/globals-bp';
//import 'Utils/mere.js';
//import 'Modules/map-container';
//import { InitializeMapDestinations } from 'SrcJS/maps/mapbox-custom';

//import { hasMapDestinations, MapDestinationsElement } from 'SrcJS/maps/mapbox-custom--dependencies';
import { LazyInitializer } from 'Utils/LazyInitializer';

var hasHotelListWithPricesDependencies = hasHotelListWithPrices();
var PackageCardsViewModel = undefined;
async function getComponent_HotelListWithPrices() {
    await import('Utils/formatters');
    await import('SrcJS/knockout-extensions/knockout.spinner');
    //await import('SrcJS/knockout-extensions/knockout.datepicker');

    const { PackageCardsViewModel } = await import('KM/PackageCardsViewModel');
    //console.log('>>> loaded: KM/PackageCardsViewModel');
    return { PackageCardsViewModel };
}


AppLoader.loaded(async function () {
    //InitializePackageCards();
    if (hasHotelListWithPricesDependencies) {

        let init_hotelListWithPrices = async function () {
            if (typeof PackageCardsViewModel == "undefined") {
                PackageCardsViewModel = (await getComponent_HotelListWithPrices()).PackageCardsViewModel;
            }
            InitializePackageCards();
            return true;
        }
        
        let hotelListWithPricesElement = HotelListWithPricesElement();
        let lazyInitializer = new LazyInitializer(hotelListWithPricesElement, init_hotelListWithPrices);
        lazyInitializer.init().then((result) => {
            //console.log('>>> lazyInitializer >> InitializePackageCards done', result);
        });
        //lazyInitializer.init();
    }
});




function HotelListWithPricesElement() {
    return document.querySelector('#hotelListWithPrices');
}

function hasHotelListWithPrices() {
    let result =  (HotelListWithPricesElement() != null);
    //console.log('>>> hasHotelListWithPrices: ' + result);
    return result;
}

function InitializePackageCards() {
    let catched = false;
    let init_done = false;
    let init_PackageCards = function () {
        //console.log('>> GlobalEvents.SearchViewModel.Initialized: ', arguments);
        if (init_done) {
            return;
        } else {
            init_done = true;
        }


        if (typeof searchViewModel == "undefined" || !searchViewModel) {
            //console.log('>>> Nofound searchViewModel: ', searchViewModel);
            return;
        }

        // 3. Initialize model
        if (hasHotelListWithPrices()) {
            searchViewModel.PackageCards(new PackageCardsViewModel(searchViewModel));
            InitScript_PackageCardsSettings();

            let isLandingPage = false;
            let pageId = searchViewModel.PageID() || AppData.CurrentPageId;
            if (AppData.CurrentLandingPageId && AppData.CurrentLandingPageId > 0) {
                isLandingPage = true;
                pageId = AppData.CurrentLandingPageId;
            }

            let packageCards = searchViewModel.PackageCards();
            packageCards.LandingPageMode(isLandingPage);
            packageCards.PageId(pageId);
            packageCards.SetDefaultDepartureAirportCode();
            packageCards.SubscribeSearching();
            packageCards.SearchPackageCards();
            packageCards.RetrievingDataReady(true);
        }
    };

    
    if (searchViewModel) {
        if (searchViewModel.Initialized()) {
            init_PackageCards();
            catched = true;
        } else {
            let subscribe_handler = function (newValue) {
                if (!newValue) {
                    // try one more time later
                    searchViewModel.Initialized.subscribeOnce(subscribe_handler);
                    return;
                }

                init_PackageCards();
            };
            searchViewModel.Initialized.subscribeOnce(subscribe_handler);
        }
    }
    if (!catched) {
        AppLoader.on(GlobalEvents.SearchViewModel.Initialized, init_PackageCards);
    }
}

function InitScript_PackageCardsSettings() {
    // moved from *.cshtml view

    if (!AppData)
        return;
    if (!AppData.HotelListWithPricesSettings)
        return;

    let packageCards = searchViewModel.PackageCards();
    if (!packageCards)
        return;

    let visibleHotels = AppData.HotelListWithPricesSettings.VisibleHotels;
    if (typeof visibleHotels != "undefined") {
        packageCards.VisibleHotels(visibleHotels);
    }

    let minimalShown = AppData.HotelListWithPricesSettings.MinimalShown;
    if (typeof minimalShown != "undefined") {
        packageCards.MinimalShown(minimalShown);
    }

    let firstDepartureDate = AppData.HotelListWithPricesSettings.FirstDepartureDate;
    if (typeof firstDepartureDate != "undefined") {
        packageCards.FirstDepartureDate(firstDepartureDate);
    }

    let lastDepartureDate = AppData.HotelListWithPricesSettings.LastDepartureDate;
    if (typeof lastDepartureDate != "undefined") {
        packageCards.LastDepartureDate(lastDepartureDate);
    }

    let nights = AppData.HotelListWithPricesSettings.Nights;
    if (typeof nights != "undefined") {
        packageCards.Nights(nights);
    }

    let numberOfHotels = AppData.HotelListWithPricesSettings.NumberOfHotels;
    if (typeof numberOfHotels != "undefined") {
        packageCards.NumberOfHotels(numberOfHotels);
    }
    
}

